import { render, staticRenderFns } from "./address-list.vue?vue&type=template&id=472b893c&scoped=true"
import script from "./address-list.vue?vue&type=script&lang=js"
export * from "./address-list.vue?vue&type=script&lang=js"
import style0 from "./address-list.vue?vue&type=style&index=0&id=472b893c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472b893c",
  null
  
)

export default component.exports